
import Select from 'react-select';
import React, { useState, useEffect } from 'react'
import axios from 'axios'
import ToastNotification from '../../../components/ToastNotification';
import { useLoading } from '../../../context/LoadingContext';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver"; 
import { MdLocalPrintshop } from "react-icons/md";
import { FaSearch } from "react-icons/fa";

function CRMReport() {
 
    const { setLoading } = useLoading();
     const [noteType, setNoteType] = useState(null);
       const [issueDate, setIssueDate] = useState('');
       const [fetchData, setfetchData] = useState([]);
     
       const [fromDate, setFromDate] = useState('');
       const [toDate, setToDate] = useState('');
         const [accountDetail, setAccountDetail] = useState([]);
     const [fetchSale, setFetchSale] = useState([]);
    const [amc, setAmc] = useState([]);
             const [fetchRepairInvoice, setFetchRepairInvoice] = useState([]);
       const[fetchPurhcase,setFetchPurchase] = useState([]);  
    
       const reportOptions = [
           { value: 'followup_due', label: 'Followup Due  ' },
    { value: 'followup_status', label: 'Followup Status' },
  
  ]
     
  const handleSearch = async (e) => {
  e.preventDefault();

  try {
    const params = {
      note_type: noteType?.value
    };

    const paramsBill = {
      from: fromDate,
      to: toDate
    };

   
    if (noteType?.value === 'followup_status') {
      params.from_date = fromDate;
      params.to_date = toDate;
    }

    if (noteType?.value === 'followup_due') {
      params.from_date = fromDate;
      params.to_date = toDate;
    }

 
    const result = await axios.get(
      'https://api.skyguard.group/api/get-crm-report',
      { params }
    );

    setfetchData(result.data.result || []);
    console.log('Report result:', result.data.result);

  } catch (error) {
    console.error('Error fetching report:', error);
  }
};

   const handleExportExcel = () => {
      const table = document.getElementById("exportTable");
    
      if (!table) return;
    
      const worksheet = XLSX.utils.table_to_sheet(table);
      const workbook = XLSX.utils.book_new();
    
      XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Report");
    
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
    
      const data = new Blob([excelBuffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
    
      saveAs(data, "CRM_Report.xlsx");
    };

  return (
   <>
     <div className='main-section'>
         <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                <h3 className='my-3 fw-bold fs-5 golos'>CRM Report</h3>

                    <div className="row g-3 align-items-end">
            <div className="col-md-4">
              <label className='fw-bold'>Select Report</label>
              <Select
                options={reportOptions}
                placeholder="Choose Type ..."
                id="source"
                value={noteType}
       
                onChange={(selected) => {
                  setNoteType(selected);
                  setfetchData([]);
                }}
              />
            </div>

            <div className="col-md-4">
              <label className='fw-bold'>From Date</label>
              <input
                type="date"
                className="form-control"
                name="from_date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            <div className="col-md-4">
              <label className='fw-bold'>To Date</label>
              <input
                type="date"
                className="form-control"
                name="to_date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>


            <div className="col-md-12 d-flex justify-content-end align-items-end">
          
                <FaSearch size={26} className="ms-1 text-primary"
                                            style={{ cursor: "pointer" }}
                                            title="Search"
                                            onClick={handleSearch}
                                          />
                            
                                          <MdLocalPrintshop
                                            size={26}
                                            className="ms-2 text-success"
                                               onClick={handleExportExcel}
                                            style={{ cursor: "pointer" }}
                                            title="Print "
                                          />
            </div>
          </div>

          <div id="exportTable" className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
             {noteType?.value === 'followup_status' ? (
         
              <table className="table table-bordered table-striped table-hover text-center align-middle">
                <thead className='table-info' >
                  <tr>
                    <th>Sr No</th>
                   <th>Party Name</th>
                    <th>Date</th>
                    <th>Status </th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(fetchData) && fetchData.length > 0 ? (
                    fetchData.map((item, idx) => (
                      <tr key={idx}>
                        <td>{idx + 1}</td>
                      <td>{item.party_name}</td>
                        <td>{item.date}</td>
                        <td>{item.status} </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3">No  data found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            ) : noteType?.value === 'followup_due' ? (
              // 🟡 STOCK MIN TABLE
              <table className="table table-bordered table-striped table-hover text-center align-middle">
                <thead className='table-info' >
                  <tr>
                    <th>Sr No</th>
                    <th>Party Name </th>
                    <th>Enter By</th>
                    <th>Followup On</th>
                    <th>Next Followup Date</th>
                    <th>Status</th>
                     <th>Remark</th>
             
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(fetchData) && fetchData.length > 0 ? (
                    fetchData.map((item, idx) => (
                      <tr key={idx}>
                        <td>{idx + 1}</td>
                        <td>{item.party_name}</td>

                        <td>{item.created_by_name}</td>
                        <td>{item.contact_datetime}</td>
                        <td>{item.next_followup_datetime} </td>
                        <td>{item.status}  </td>
                        <td>{item.remark} </td>
                  
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4">No  data found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            )  : (
          
              <table className="table table-bordered table-striped table-hover text-center align-middle">
                <thead className='table-info'>
                  <tr>
                    <th>Sr No</th>
                    <th>Source</th>
                    <th>Name</th>
                    <th>Date</th>
                  </tr>
                </thead>
         

              </table>
            )}
          </div>
         </div>
     </div>
   </>
  )
}

export default CRMReport